module.exports = __webpack_public_path__ + "img/Delivery location Icon - charcoal.f147f30f.svg";